/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  challengeIssueDetailSchema,
  challengeIssueSourceSchema,
  challengeIssueStatusSchema,
} from '../enums';

const issueChallengeSchema = z.object({
  id: z.number(),
  title: z.string(),
  definition: z.string().nullable(),
});

const issueCollectionSchema = z.object({
  id: z.number(),
  title: z.string(),
});

const issueRowSchema = z.object({
  id: z.number(),
  status: challengeIssueStatusSchema,
  source: challengeIssueSourceSchema,
  reporterUserId: z.string(),
  createdAt: z.number(),
  resolvedAt: z.number().nullable(),
  resolutionNote: z.string().nullable(),
  clipId: z.number().nullable(),
  details: z.array(challengeIssueDetailSchema),
  note: z.string().nullable(),
  lang: z.string().nullable(),
  challenge: issueChallengeSchema.nullable(),
  collection: issueCollectionSchema.nullable(),
});

export type IChallengeIssueRow = z.infer<typeof issueRowSchema>;

const listDataSchema = z.object({
  items: z.array(issueRowSchema),
  total: z.number(),
});

export interface IListChallengeIssuesData {
  items: IChallengeIssueRow[];
  total: number;
}

export const listChallengeIssuesResponseSchema = createApiResponseSchema(
  listDataSchema,
) as z.ZodSchema<IAPI<IListChallengeIssuesData>>;

export type IListChallengeIssuesResponse = IAPI<IListChallengeIssuesData>;
